import React, {createContext, useContext} from 'react'
import PropTypes from 'prop-types'

const GDIDynamicContentContext = createContext({})

export const GDIDynamicContentProvider = ({children, value}) => {
    return (
        <GDIDynamicContentContext.Provider value={value || {}}>
            {children}
        </GDIDynamicContentContext.Provider>
    )
}

export const useGDIDynamicContentContext = () => useContext(GDIDynamicContentContext)

GDIDynamicContentProvider.propTypes = {
    children: PropTypes.node,
    value: PropTypes.object
}
